import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "content", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--dashboards--costs--dashboard`
  }

  doCostsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-12 px-0" data-${this.controllerName}-target="content" data-controller="financials--books--dashboards--costs--index
                                                                                                         financials--books--dashboards--costs--show
                                                                                                         financials--books--dashboards--costs--save"></div>
                </div>`
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`financials--books--dashboards--main--page`).settingsTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier("financials--books--dashboards--costs--index").doIndexListHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // })

}
